(function () {
        var header = document.querySelector('.hf-mega-header[data-hf-header]');
    if (!header) return;

        var overlay = header.querySelector('[data-hf-overlay]');
    var shell = header.querySelector('[data-hf-shell]');
    var clickArea = header.querySelector('[data-hf-click-area]');
    var mobileToggle = header.querySelector('[data-hf-mobile-toggle]');
    var topTriggers = header.querySelectorAll('[data-hf-top-trigger]');
    var panels = header.querySelectorAll('[data-hf-panel]');
    var secondTriggers = header.querySelectorAll('[data-hf-second-trigger]');
    var rightPlaceholders = header.querySelectorAll('[data-hf-right-placeholder]');
    var searchTrigger = header.querySelector('[data-hf-search-trigger]');
    var searchPanel = header.querySelector('[data-hf-search-panel]');
    var searchInput = header.querySelector('[data-hf-search-input]');
    var searchClear = header.querySelector('[data-hf-search-clear]');
    var searchEmptyClear = header.querySelector('[data-hf-search-empty-clear]');
    var searchDefault = header.querySelector('[data-hf-search-default]');
    var searchResults = header.querySelector('[data-hf-search-results]');
    var searchEmpty = header.querySelector('[data-hf-search-empty]');
    var searchList = header.querySelector('[data-hf-search-list]');
    var searchViewAll = header.querySelector('[data-hf-search-view-all]');
    var suggestedSearches = header.querySelectorAll('[data-hf-suggested-query]');
        var cartTrigger = header.querySelector('[data-hf-cart-trigger]');
        var notificationsTrigger = header.querySelector('[data-hf-notifications-trigger]');
var notificationsPanel = header.querySelector('[data-hf-notifications-panel]');
var notificationsWrap = header.querySelector('[data-hf-notifications-wrap]');
var notificationsFeed = header.querySelector('[data-hf-notifications-feed]');
var notificationItems = header.querySelectorAll('[data-hf-notification-item]');
var notificationDetail = header.querySelector('[data-hf-notification-detail]');
var notificationBack = header.querySelector('[data-hf-notification-back]');
var notificationDetailImage = header.querySelector('[data-hf-notification-detail-image]');
var notificationDetailTitle = header.querySelector('[data-hf-notification-detail-title]');
var notificationDetailBody = header.querySelector('[data-hf-notification-detail-body]');
var notificationDetailButton = header.querySelector('[data-hf-notification-detail-button]');
var notificationDetailSecondButton = header.querySelector('[data-hf-notification-detail-second-button]');
    var cartPanel = header.querySelector('[data-hf-cart-panel]');
    var cartCount = header.querySelector('[data-hf-cart-count]');
    var cartEmpty = header.querySelector('[data-hf-cart-empty]');
    var cartFilled = header.querySelector('[data-hf-cart-filled]');
    var cartItems = header.querySelector('[data-hf-cart-items]');
    var cartSubtotal = header.querySelector('[data-hf-cart-subtotal]');
    var cartCheckout = header.querySelector('[data-hf-cart-checkout]');
    var cartShippingCopy = header.querySelector('[data-hf-cart-shipping-copy]');
    var cartShippingProgress = header.querySelector('[data-hf-cart-shipping-progress]');
    var cartItemTemplate = header.querySelector('[data-hf-cart-item-template]');
    var cartTaxCopy = header.querySelector('[data-hf-cart-tax-copy]');
    var recentlyViewedBlock = header.querySelector('[data-hf-recently-viewed]');
var recentlyViewedList = header.querySelector('[data-hf-recently-viewed-list]');
var cartEmptyRecentlyViewedBlock = header.querySelector('[data-hf-cart-empty-recently-viewed]');
var cartEmptyRecentlyViewedList = header.querySelector('[data-hf-cart-empty-recently-viewed-list]');
    var logo = document.querySelector('[data-hf-logo]');
    var INTRO_KEY = 'hfMenuIntroSeen';
    var mainEl = document.getElementById('main');
    var path = window.location.pathname || '';
    var brandEl = document.querySelector('.hf-mega-header__brand');
    var brandBaseTranslate = '-50%';
    var topAnnouncement = null;
    var syncMainOffsetRaf = null;
    var predictiveAbort = null;
var predictiveDebounce = null;
var currencyCode = 'CAD';
var productDataCache = {};
var memberDiscountEligibilityCache = {};
var FREE_SHIPPING_THRESHOLD = 99;
var cartRequestPromise = null;
var memberDiscountProductMap = null;
var MEMBER_DISCOUNT_COLLECTION_HANDLE = 'qualifies-for-members-discount';
var NOTIFICATION_READ_STATE_KEY = 'hfNotificationReadState';

    function getAnnouncementSelectorCandidates() {
      return [
        '#shopify-section-sections--21769528475891__custom_liquid_WCEQda',
        '[id$="__custom_liquid_WCEQda"]',
        '.shopify-section-group-header-group[id$="__custom_liquid_WCEQda"]',
        '.shopify-section--custom-liquid[id$="__custom_liquid_WCEQda"]'
      ];
    }

    
    function mountBrandToBody() {
      if (!brandEl) return;
      if (brandEl.parentNode !== document.body) {
        document.body.appendChild(brandEl);
      }
      brandEl.style.position = 'fixed';
      brandEl.style.zIndex = '2147483647';
      brandEl.style.overflow = 'visible';
      brandEl.style.clipPath = 'none';
      brandEl.style.webkitClipPath = 'none';
      brandEl.style.mask = 'none';
      brandEl.style.webkitMask = 'none';
    }
    function queueSyncMainOffset() {
      if (syncMainOffsetRaf) return;
      syncMainOffsetRaf = window.requestAnimationFrame(function () {
        syncMainOffsetRaf = null;
        syncMainOffset();
        updateScrolledState();
        updateLogoVariant();
      });
    }

    function getNotificationReadState() {
      try {
        var raw = window.localStorage.getItem(NOTIFICATION_READ_STATE_KEY);
        if (!raw) return {};
        var parsed = JSON.parse(raw);
        return parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : {};
      } catch (error) {
        return {};
      }
    }

    function saveNotificationReadState(state) {
      try {
        window.localStorage.setItem(NOTIFICATION_READ_STATE_KEY, JSON.stringify(state || {}));
      } catch (error) {}
    }

    function markNotificationAsRead(notificationId) {
      if (!notificationId) return;
      var state = getNotificationReadState();
      if (state[notificationId] === true) return;
      state[notificationId] = true;
      saveNotificationReadState(state);
    }

    function updateNotificationUnreadUi() {
      var state = getNotificationReadState();
      var hasUnread = false;

      notificationItems.forEach(function (item) {
        var notificationId = item.getAttribute('data-notification-id') || '';
        var badge = item.querySelector('[data-hf-notification-badge]');
        var isRead = !!state[notificationId];

        item.classList.toggle('is-read', isRead);

        if (badge) {
          badge.hidden = isRead;
        }

        if (!isRead) {
          hasUnread = true;
        }
      });

      var notificationsDot = header.querySelector('[data-hf-notifications-dot]');
      if (notificationsDot) {
        notificationsDot.hidden = !hasUnread;
      }
    }

    function formatMoney(value) {
  if (value == null || value === '') return '';
  var num = value;
  if (typeof num === 'string') num = parseFloat(num);
  if (Number.isNaN(num)) return '';

  try {
    return new Intl.NumberFormat('en-CA', {
      style: 'currency',
      currency: currencyCode
    }).format(num);
  } catch (error) {
    return '$' + Number(num).toFixed(2);
  }
}

function formatMoneyFromCents(cents) {
  if (cents == null || cents === '') return '';
  var num = Number(cents);
  if (Number.isNaN(num)) return '';
  return formatMoney(num / 100);
}

function getCartData() {
  cartRequestPromise = fetch('/cart.js', {
    headers: { Accept: 'application/json' }
  })
    .then(function (response) {
      if (!response.ok) throw new Error('Cart fetch failed');
      return response.json();
    })
    .catch(function () {
      return null;
    });

  return cartRequestPromise;
}

function updateCartTaxCopy() {
  if (!cartTaxCopy) return;
  cartTaxCopy.textContent = 'Taxes and shipping calculated at checkout.';
}

function getMemberDiscountProductMap() {
  if (memberDiscountProductMap) return memberDiscountProductMap;

  memberDiscountProductMap = {};

  var dataNode = header.querySelector('[data-hf-member-discount-products]');
  if (!dataNode) return memberDiscountProductMap;

  try {
    var parsed = JSON.parse(dataNode.textContent || '{}');
    if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) {
      Object.keys(parsed).forEach(function (id) {
        var normalized = String(id == null ? '' : id).trim();
        if (!normalized) return;
        memberDiscountProductMap[normalized] = parsed[id] === true;
      });
    }
  } catch (error) {}

  return memberDiscountProductMap;
}

function rebuildMemberDiscountProductMapFromCart(cart) {
  var baseMap = {};
  var dataNode = header.querySelector('[data-hf-member-discount-products]');

  if (dataNode) {
    try {
      var parsed = JSON.parse(dataNode.textContent || '{}');
      if (parsed && typeof parsed === 'object' && !Array.isArray(parsed)) {
        Object.keys(parsed).forEach(function (id) {
          var normalized = String(id == null ? '' : id).trim();
          if (!normalized) return;
          baseMap[normalized] = parsed[id] === true;
        });
      }
    } catch (error) {}
  }

  memberDiscountProductMap = baseMap;

  if (!cart || !Array.isArray(cart.items) || !cart.items.length) {
    return memberDiscountProductMap;
  }

  cart.items.forEach(function (item) {
    if (!item || item.product_id == null) return;

    var productId = String(item.product_id);
var fullProduct = item.__fullProduct;
var collections = fullProduct && Array.isArray(fullProduct.collections) ? fullProduct.collections : null;

if (collections && collections.length) {
  memberDiscountProductMap[productId] = collections.some(function (collection) {
    return collection && collection.handle === MEMBER_DISCOUNT_COLLECTION_HANDLE;
  });
} else if (item.__memberDiscountEligible === true) {
  memberDiscountProductMap[productId] = true;
} else if (typeof memberDiscountProductMap[productId] === 'undefined') {
  memberDiscountProductMap[productId] = false;
}
  });

  return memberDiscountProductMap;
}

function isMemberDiscountEligibleItem(item) {
  if (!item || item.product_id == null) return false;
  return getMemberDiscountProductMap()[String(item.product_id)] === true;
}

function createCartLineMemberDiscountMessage(item) {
  if (!item) return null;
  if (!isMemberDiscountEligibleItem(item)) return null;
  if (getCartLineDiscountData(item)) return null;

  var message = document.createElement('div');
  message.className = 'hf-mega-header__cart-item-member-message';

  var icon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  icon.setAttribute('aria-hidden', 'true');
  icon.setAttribute('focusable', 'false');
  icon.setAttribute('width', '12');
  icon.setAttribute('height', '12');
  icon.setAttribute('viewBox', '0 0 12 12');
  icon.setAttribute('fill', 'none');
  icon.setAttribute('class', 'icon icon-alert');

  var circle = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
  circle.setAttribute('cx', '6');
  circle.setAttribute('cy', '6');
  circle.setAttribute('r', '4.75');
  circle.setAttribute('stroke', 'currentColor');
  circle.setAttribute('stroke-width', '1.5');

  var line = document.createElementNS('http://www.w3.org/2000/svg', 'path');
  line.setAttribute('d', 'M6 3.1V6.2');
  line.setAttribute('stroke', 'currentColor');
  line.setAttribute('stroke-width', '1.5');
  line.setAttribute('stroke-linecap', 'round');

  var dot = document.createElementNS('http://www.w3.org/2000/svg', 'circle');
  dot.setAttribute('cx', '6');
  dot.setAttribute('cy', '8.65');
  dot.setAttribute('r', '0.8');
  dot.setAttribute('fill', 'currentColor');

  icon.appendChild(circle);
  icon.appendChild(line);
  icon.appendChild(dot);

  var text = document.createElement('span');
  text.className = 'hf-mega-header__cart-item-member-message-text';
  text.textContent = 'You could save 10% off this item.';

  var link = document.createElement('a');
  link.className = 'hf-mega-header__cart-item-member-message-link';
  link.href = 'https://www.monodsports.com/pages/best-price-guarantee#membership';
  link.textContent = 'Learn how';

  message.appendChild(icon);
  message.appendChild(text);
  message.appendChild(link);

  return message;
}



function getCartLineImage(item) {
  if (!item) return 'https://placehold.co/240x300/e9ecef/222222?text=No+Image';

  if (item.featured_image && item.featured_image.url) return item.featured_image.url;
  if (item.featured_image && item.featured_image.src) return item.featured_image.src;
  if (typeof item.featured_image === 'string' && item.featured_image) return item.featured_image;
  if (item.image) return item.image;
  if (item.product_has_only_default_variant && item.featured_image) return item.featured_image;

  return 'https://placehold.co/240x300/e9ecef/222222?text=No+Image';
}

function getCartLineVariantText(item) {
  if (!item) return '';

  if (item.variant_title && item.variant_title.toLowerCase() !== 'default title') {
    return item.variant_title;
  }

  if (Array.isArray(item.options_with_values)) {
    return item.options_with_values
      .map(function (option) {
        return option && option.value ? option.value : '';
      })
      .filter(Boolean)
      .join(' / ');
  }

  return '';
}

function getCartLineUrl(item) {
  if (!item) return '/cart';

  if (item.url) return item.url;
  if (item.handle) return '/products/' + item.handle;
  if (item.product_handle) return '/products/' + item.product_handle;

  return '/cart';
}


function getCartLineKey(item) {
  if (!item) return '';
  return String(item.key || '');
}


function getCartLineDiscountData(item) {
  if (!item) return null;

  var allocations = Array.isArray(item.line_level_discount_allocations) ? item.line_level_discount_allocations : [];
  if (!allocations.length) return null;

  var titles = [];
  var totalAmount = 0;

  allocations.forEach(function (allocation) {
    if (!allocation) return;

    var title = '';
    if (allocation.discount_application && allocation.discount_application.title) {
      title = allocation.discount_application.title;
    } else if (allocation.title) {
      title = allocation.title;
    }

    if (title && titles.indexOf(title) === -1) {
      titles.push(title);
    }

    var amount = Number(allocation.amount || 0);
    if (!Number.isNaN(amount)) {
      totalAmount += amount;
    }
  });

  if (!titles.length && !totalAmount) return null;

  return {
    title: titles.join(', '),
    amountText: totalAmount > 0 ? '(-' + formatMoneyFromCents(totalAmount) + ')' : ''
  };
}

function getCartLinePricingDisplay(item) {
  if (!item) {
    return {
      compareText: '',
      priceText: '',
      totalText: '',
      onSale: false,
      showUnitBreakdown: false
    };
  }

  var quantity = Math.max(1, Number(item.quantity || 1));
  var finalLinePrice = Number(item.final_line_price || 0);
  var finalPriceEach = Number(item.final_price || 0);
  var originalLinePrice = Number(item.original_line_price || 0);
  var originalPriceEach = Number(item.original_price || 0);

  if (originalLinePrice > finalLinePrice) {
    return {
      compareText: quantity > 1 ? formatMoneyFromCents(originalPriceEach) + ' each' : formatMoneyFromCents(originalLinePrice),
      priceText: quantity > 1 ? formatMoneyFromCents(finalPriceEach) + ' each' : formatMoneyFromCents(finalLinePrice),
      totalText: quantity > 1 ? 'Total ' + formatMoneyFromCents(finalLinePrice) : '',
      onSale: true,
      showUnitBreakdown: quantity > 1
    };
  }

  var fullProduct = item.__fullProduct;
  if (fullProduct && Array.isArray(fullProduct.variants)) {
    var variantId = Number(item.variant_id || 0);
    var matchedVariant = fullProduct.variants.find(function (variant) {
      return Number(variant && variant.id ? variant.id : 0) === variantId;
    });

    if (matchedVariant) {
      var compareAtPrice = Number(matchedVariant.compare_at_price || 0);
      var currentPrice = Number(matchedVariant.price || 0);

      if (compareAtPrice > currentPrice) {
        return {
          compareText: quantity > 1 ? formatMoneyFromCents(compareAtPrice) + ' each' : formatMoneyFromCents(compareAtPrice * quantity),
          priceText: quantity > 1 ? formatMoneyFromCents(finalPriceEach || currentPrice) + ' each' : formatMoneyFromCents(finalLinePrice || currentPrice * quantity),
          totalText: quantity > 1 ? 'Total ' + formatMoneyFromCents(finalLinePrice || currentPrice * quantity) : '',
          onSale: true,
          showUnitBreakdown: quantity > 1
        };
      }
    }
  }

  return {
    compareText: '',
    priceText: formatMoneyFromCents(finalLinePrice),
    totalText: '',
    onSale: false,
    showUnitBreakdown: false
  };
}

function createCartLineDiscountBadge(item) {
  var discountData = getCartLineDiscountData(item);
  if (!discountData) return null;

  var badge = document.createElement('div');
  badge.className = 'hf-mega-header__cart-item-discount-badge';

  var icon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  icon.setAttribute('aria-hidden', 'true');
  icon.setAttribute('focusable', 'false');
  icon.setAttribute('width', '10');
  icon.setAttribute('class', 'icon icon-discount');
  icon.setAttribute('viewBox', '0 0 13 13');
  icon.setAttribute('fill', 'none');

  var path1 = document.createElementNS('http://www.w3.org/2000/svg', 'path');
  path1.setAttribute('d', 'M9.94238 3.05795L11.6146 1.38574');
  path1.setAttribute('stroke', 'currentColor');
  path1.setAttribute('stroke-width', '1.5');

  var path2 = document.createElementNS('http://www.w3.org/2000/svg', 'path');
  path2.setAttribute('fill-rule', 'evenodd');
  path2.setAttribute('clip-rule', 'evenodd');
  path2.setAttribute('d', 'M10.4424 7.16699L10.2959 7.3125L5.00098 12.6084L4.64648 12.9619L0.0380859 8.35254L5.83301 2.55762H10.4424V7.16699ZM7.16699 5.13477L7.87402 5.8418L8.62402 5.0918L7.91699 4.38477L7.16699 5.13477Z');
  path2.setAttribute('fill', 'currentColor');

  icon.appendChild(path1);
  icon.appendChild(path2);

  var text = document.createElement('span');
  text.className = 'hf-mega-header__cart-item-discount-badge-text';
  text.textContent = (discountData.title || 'Discount') + (discountData.amountText ? ' ' + discountData.amountText : '');

  badge.appendChild(icon);
  badge.appendChild(text);

  return badge;
}

function findCartLineByReference(cart, lineKey, lineNumber) {
  if (!cart || !Array.isArray(cart.items)) return null;

  if (lineNumber != null && !Number.isNaN(Number(lineNumber))) {
    var byLine = cart.items[Number(lineNumber) - 1];
    if (byLine) return byLine;
  }

  if (lineKey) {
    for (var i = 0; i < cart.items.length; i += 1) {
      if (String(cart.items[i].key || '') === String(lineKey)) {
        return cart.items[i];
      }
    }
  }

  return null;
}

function showCartLineStockMessage(lineKey, lineNumber, message) {
  if (!cartItems) return;

  var lineNode = null;

  if (lineNumber != null && !Number.isNaN(Number(lineNumber))) {
    lineNode = cartItems.querySelector('[data-line-number="' + String(lineNumber) + '"]');
  }

  if (!lineNode && lineKey) {
    lineNode = cartItems.querySelector('[data-line-key="' + String(lineKey).replace(/"/g, '\\"') + '"]');
  }

  if (!lineNode) return;

  var stockMessage = lineNode.querySelector('.hf-mega-header__cart-item-stock-message');
  if (!stockMessage) return;

  stockMessage.hidden = false;
  stockMessage.textContent = message || 'No more stock available';
}

function clearCartLineStockMessages() {
  if (!cartItems) return;
  cartItems.querySelectorAll('.hf-mega-header__cart-item-stock-message').forEach(function (node) {
    node.hidden = true;
    node.textContent = '';
  });
}

function changeCartLineQuantity(lineKey, quantity, lineNumber) {
  var normalizedQuantity = Math.max(0, Number(quantity) || 0);
  var payload = { quantity: normalizedQuantity };

  clearCartLineStockMessages();

  if (lineNumber != null && !Number.isNaN(Number(lineNumber))) {
    payload.line = Number(lineNumber);
  } else if (lineKey) {
    payload.id = lineKey;
  } else {
    return Promise.resolve(null);
  }

  return fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json'
    },
    body: JSON.stringify(payload)
  })
    .then(function (response) {
      if (!response.ok) {
        return response.json().catch(function () {
          return {};
        }).then(function (errorPayload) {
          var error = new Error((errorPayload && (errorPayload.description || errorPayload.message)) || 'Cart change failed');
          error.cartErrorMessage = (errorPayload && (errorPayload.description || errorPayload.message)) || 'No more stock available';
          throw error;
        });
      }

      return response.json();
    })
    .then(function (cart) {
  return enrichCartItemsWithProductData(cart).then(function (enrichedCart) {
    var updatedLine = findCartLineByReference(enrichedCart, lineKey, lineNumber);
    var stockLimited = normalizedQuantity > 0 && updatedLine && Number(updatedLine.quantity || 0) < normalizedQuantity;
    rebuildMemberDiscountProductMapFromCart(enrichedCart);
    renderCart(enrichedCart, {
      stockLimitedLineKey: stockLimited ? String(updatedLine.key || lineKey || '') : '',
      attemptedQuantity: stockLimited ? normalizedQuantity : null,
      actualQuantity: stockLimited ? Number(updatedLine.quantity || 0) : null
    });

    if (stockLimited) {
      showCartLineStockMessage(String(updatedLine.key || lineKey || ''), lineNumber, 'No more stock available');
    }

    return enrichedCart;
  });
})
    .catch(function (error) {
      showCartLineStockMessage(lineKey, lineNumber, (error && error.cartErrorMessage) || 'No more stock available');
      return null;
    });
}

function createCartLineItem(item, lineNumber) {
  if (!cartItemTemplate) return document.createDocumentFragment();

  var fragment = cartItemTemplate.content.cloneNode(true);
  var root = fragment.querySelector('[data-hf-cart-line]');
  var links = fragment.querySelectorAll('[data-hf-cart-line-link]');
  var image = fragment.querySelector('[data-hf-cart-line-image]');
  var vendor = fragment.querySelector('[data-hf-cart-line-vendor]');
  var title = fragment.querySelector('[data-hf-cart-line-title]');
  var variant = fragment.querySelector('[data-hf-cart-line-variant]');
  var quantityValue = fragment.querySelector('[data-hf-cart-line-quantity]');
  var quantityPicker = fragment.querySelector('[data-hf-cart-line-quantity-picker]');
  var decreaseButton = fragment.querySelector('[data-hf-cart-line-decrease]');
  var increaseButton = fragment.querySelector('[data-hf-cart-line-increase]');
  var removeButton = fragment.querySelector('[data-hf-cart-line-remove]');
  var compare = fragment.querySelector('[data-hf-cart-line-price-compare]');
  var price = fragment.querySelector('[data-hf-cart-line-price]');

  var url = getCartLineUrl(item);
  var quantity = item && item.quantity ? item.quantity : 0;
  var lineKey = getCartLineKey(item);
  var pricingDisplay = getCartLinePricingDisplay(item);
  var discountBadge = createCartLineDiscountBadge(item);
  var memberDiscountMessage = createCartLineMemberDiscountMessage(item);
  var stockMessage = document.createElement('span');
  stockMessage.className = 'hf-mega-header__cart-item-stock-message';
  stockMessage.hidden = true;

  if (root) {
    root.setAttribute('data-line-key', lineKey);
    root.setAttribute('data-line-number', String(lineNumber || ''));
  }

  if (root) {
    if (discountBadge) {
      root.insertAdjacentElement('afterbegin', discountBadge);
    } else if (memberDiscountMessage) {
      root.insertAdjacentElement('afterbegin', memberDiscountMessage);
    }
  }

  links.forEach(function (link) {
    link.href = url;
  });

  if (image) {
    image.src = getCartLineImage(item);
    image.alt = item && item.product_title ? item.product_title : 'Cart item';
  }

  if (vendor) {
    vendor.textContent = item && item.vendor ? item.vendor : '';
    vendor.hidden = !vendor.textContent;
  }

  if (title) {
    title.textContent = item && item.product_title ? item.product_title : '';
  }

  if (variant) {
    variant.textContent = getCartLineVariantText(item);
    variant.hidden = !variant.textContent;
  }

  if (quantityValue) {
    quantityValue.textContent = String(quantity);
  }

  if (quantityPicker) {
    quantityPicker.insertAdjacentElement('afterend', stockMessage);
  }

  if (compare) {
    if (pricingDisplay.compareText) {
      compare.textContent = pricingDisplay.compareText;
      compare.hidden = false;
    } else {
      compare.textContent = '';
      compare.hidden = true;
    }
  }

  if (price) {
    price.className = 'hf-mega-header__cart-item-price' + (pricingDisplay.onSale ? ' is-sale' : '');

    if (pricingDisplay.totalText) {
      price.innerHTML = '<span class="hf-mega-header__cart-item-price-main">' +
        escapeHtml(pricingDisplay.priceText) +
        '</span><span class="hf-mega-header__cart-item-price-total">' +
        escapeHtml(pricingDisplay.totalText) +
        '</span>';
    } else {
      price.textContent = pricingDisplay.priceText;
    }
  }

  if (decreaseButton) {
    decreaseButton.disabled = quantity <= 1;
    decreaseButton.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      if (quantity > 1) {
        changeCartLineQuantity(lineKey, quantity - 1, lineNumber);
      }
    });
  }

  if (increaseButton) {
    increaseButton.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      changeCartLineQuantity(lineKey, quantity + 1, lineNumber);
    });
  }

  if (removeButton) {
    removeButton.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopPropagation();
      changeCartLineQuantity(lineKey, 0, lineNumber);
    });
  }

  return fragment;
}

function renderCartCount(count) {
  if (!cartCount) return;

  if (count > 0) {
    cartCount.textContent = String(count);
    cartCount.hidden = false;
    if (cartTrigger) {
      cartTrigger.setAttribute('aria-label', 'Open cart (' + count + ')');
    }
  } else {
    cartCount.textContent = '0';
    cartCount.hidden = true;
    if (cartTrigger) {
      cartTrigger.setAttribute('aria-label', 'Open cart');
    }
  }
}

function renderCartShipping(totalCents) {
  if (!cartShippingCopy || !cartShippingProgress) return;

  var total = Number(totalCents || 0) / 100;
  var remaining = Math.max(FREE_SHIPPING_THRESHOLD - total, 0);
  var progressPercent = Math.max(0, Math.min((total / FREE_SHIPPING_THRESHOLD) * 100, 100));

  if (remaining > 0) {
    cartShippingCopy.textContent = 'Spend ' + formatMoney(remaining) + ' more to get free shipping.';
  } else {
    cartShippingCopy.textContent = 'You qualify for free shipping.';
  }

  cartShippingProgress.style.width = progressPercent + '%';
}

function renderCart(cart, options) {
  options = options || {};
  var itemCount = cart && cart.item_count ? cart.item_count : 0;
  renderCartCount(itemCount);

  if (!cartItems || !cartEmpty || !cartFilled || !cartSubtotal) return;

  cartItems.innerHTML = '';
  clearCartLineStockMessages();
  cartSubtotal.textContent = formatMoneyFromCents(cart && cart.total_price ? cart.total_price : 0);

  if (cartCheckout) {
    cartCheckout.setAttribute('href', '/checkout');
  }

  updateCartTaxCopy();

  if (!cart || !Array.isArray(cart.items) || !cart.items.length) {
  cartEmpty.hidden = false;
  cartFilled.hidden = true;
  renderCartShipping(0);
  loadRecentlyViewedProducts();
  return;
}

  cartEmpty.hidden = true;
  cartFilled.hidden = false;

  cart.items.forEach(function (item, index) {
    var lineFragment = createCartLineItem(item, index + 1);
    cartItems.appendChild(lineFragment);

    if (options.stockLimitedLineKey && String(item.key || '') === String(options.stockLimitedLineKey)) {
      var lineNode = cartItems.lastElementChild;
      if (lineNode) {
        var stockMessage = lineNode.querySelector('.hf-mega-header__cart-item-stock-message');
        if (stockMessage) {
          stockMessage.hidden = false;
          stockMessage.textContent = options.stockLimitedMessage || 'No more stock available';
        }
      }
    }
  });

  renderCartShipping(cart.total_price || 0);
}

function enrichCartItemsWithProductData(cart) {
  if (!cart || !Array.isArray(cart.items) || !cart.items.length) {
    return Promise.resolve(cart);
  }

  return Promise.all(cart.items.map(function (item) {
    var handle = item && (item.handle || item.product_handle) ? (item.handle || item.product_handle) : '';

    if (!handle && item && item.url && item.url.indexOf('/products/') > -1) {
      handle = item.url.split('/products/').pop().split('?')[0].split('#')[0];
    }

    if (!handle) {
      item.__fullProduct = null;
      item.__memberDiscountEligible = false;
      return null;
    }

    return Promise.all([
      getProductDataByHandle(handle),
      getMemberDiscountEligibilityByHandle(handle)
    ]).then(function (results) {
      item.__fullProduct = results[0] || null;
      item.__memberDiscountEligible = results[1] === true;
      return null;
    });
  })).then(function () {
    return cart;
  });
}

function loadCart() {
  return getCartData().then(function (cart) {
    if (!cart || !Array.isArray(cart.items) || !cart.items.length) {
      renderCart(cart, {});
      return cart;
    }

        return enrichCartItemsWithProductData(cart).then(function (enrichedCart) {
      rebuildMemberDiscountProductMapFromCart(enrichedCart);
      renderCart(enrichedCart, {});
      return enrichedCart;
    });
  });
}

function openCartAfterAdd() {
  loadCart().then(function () {
    openCartPanel();
  });
}

        function collectVariantSwatches(product) {
      if (!product || !Array.isArray(product.variants) || !product.variants.length) return {
        items: [],
        totalColors: 0
      };

      var seen = new Set();
      var allSwatches = [];
      var colorIndex = -1;

      if (Array.isArray(product.options) && product.options.length) {
        for (var i = 0; i < product.options.length; i += 1) {
          var option = product.options[i];
          var optionName = typeof option === 'string'
            ? option
            : option && (option.name || option.title || '');
          optionName = (optionName + '').trim().toLowerCase();
          if (optionName.indexOf('color') > -1 || optionName.indexOf('colour') > -1) {
            colorIndex = i;
            break;
          }
        }
      }

      // Never treat Size, Ski Length, Width, Fit, or another first option as a
      // colour. Products without an explicitly named Color/Colour option should
      // not render a swatch row in header product cards.
      if (colorIndex < 0) return {
        items: [],
        totalColors: 0
      };

      product.variants.forEach(function (variant) {
        var label = '';
        if (Array.isArray(variant.options) && variant.options.length > colorIndex) {
          label = variant.options[colorIndex];
        }
        if (!label && colorIndex === 0) label = variant.option1;
        if (!label && colorIndex === 1) label = variant.option2;
        if (!label && colorIndex === 2) label = variant.option3;
        if (!label) return;

        var rawLabel = (label + '').trim();
        if (!rawLabel) return;
        if (rawLabel.toLowerCase() === 'default title') return;

        var key = rawLabel.toLowerCase();
        if (seen.has(key)) return;
        seen.add(key);

        var imageValue = (variant.featured_image && (variant.featured_image.url || variant.featured_image.src)) || variant.featured_image || variant.image || '';
        var src = '';
        if (typeof imageValue === 'string') {
          src = imageValue;
        } else if (imageValue && typeof imageValue === 'object') {
          src = imageValue.url || imageValue.src || '';
        }

        allSwatches.push({
          label: rawLabel,
          src: src
        });
      });

      return {
        items: allSwatches.slice(0, 4),
        totalColors: allSwatches.length
      };
    }

function getProductDataByHandle(handle) {
  if (!handle) return Promise.resolve(null);
  if (productDataCache[handle]) return productDataCache[handle];

  productDataCache[handle] = fetch('/products/' + handle + '.js', {
    headers: { Accept: 'application/json' }
  })
    .then(function (response) {
      if (!response.ok) throw new Error('Product data fetch failed');
      return response.json();
    })
    .catch(function () {
      return null;
    });

  return productDataCache[handle];
}

function getMemberDiscountEligibilityByHandle(handle) {
  if (!handle) return Promise.resolve(false);
  if (typeof memberDiscountEligibilityCache[handle] !== 'undefined') {
    return Promise.resolve(memberDiscountEligibilityCache[handle]);
  }

  var url = '/collections/' + MEMBER_DISCOUNT_COLLECTION_HANDLE + '/products/' + handle;
  var expectedPath = '/collections/' + MEMBER_DISCOUNT_COLLECTION_HANDLE + '/products/' + handle;

  return fetch(url, {
    headers: { Accept: 'text/html' }
  })
    .then(function (response) {
      if (!response || !response.ok) {
        memberDiscountEligibilityCache[handle] = false;
        return false;
      }

      var finalPath = '';
      try {
        finalPath = new URL(response.url, window.location.origin).pathname.replace(/\/$/, '');
      } catch (error) {
        finalPath = '';
      }

      memberDiscountEligibilityCache[handle] = finalPath === expectedPath;
      return memberDiscountEligibilityCache[handle];
    })
    .catch(function () {
      memberDiscountEligibilityCache[handle] = false;
      return false;
    });
}

function enrichPredictiveProducts(products) {
  return Promise.all(
    (products || []).map(function (product) {
      return getProductDataByHandle(product && product.handle).then(function (fullProduct) {
        if (!fullProduct) return product;
        return {
          predictive: product,
          full: fullProduct
        };
      });
    })
  );
}

function getPricing(productRecord) {
  var predictive = productRecord && productRecord.predictive ? productRecord.predictive : productRecord;
  var full = productRecord && productRecord.full ? productRecord.full : null;

  if (full) {
    var priceText = formatMoneyFromCents(full.price);
    var compareText = full.compare_at_price && full.compare_at_price > full.price ? formatMoneyFromCents(full.compare_at_price) : '';
    return {
      priceText: priceText,
      compareText: compareText,
      onSale: !!compareText
    };
  }

  var predictivePrice = formatMoney((predictive && ((predictive.price && predictive.price.min) || predictive.price || (predictive.variants && predictive.variants[0] && predictive.variants[0].price))) || '');
  return {
    priceText: predictivePrice,
    compareText: '',
    onSale: false
  };
}

function escapeHtml(value) {
  return String(value == null ? '' : value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

function slugifyVendor(value) {
  return String(value == null ? '' : value)
    .trim()
    .toLowerCase()
    .replace(/&/g, 'and')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
}

function buildRecentlyViewedSwatchesMarkup(product) {
  var swatchData = collectVariantSwatches(product);
  var items = swatchData.items || [];
  var totalColors = swatchData.totalColors || 0;
  if (!items.length) return '';

  var swatchesHtml = items.map(function (item) {
    var label = escapeHtml(item.label || 'Colour');

    if (item.src) {
      return '' +
        '<span class="color-swatch color-swatch--circle color-swatch--sm hf-mega-header__native-swatch" title="' + label + '">' +
          '<img src="' + escapeHtml(item.src) + '" alt="' + label + '" loading="lazy">' +
          '<span class="sr-only">' + label + '</span>' +
        '</span>';
    }

    return '' +
      '<span class="color-swatch color-swatch--circle color-swatch--sm hf-mega-header__native-swatch hf-mega-header__native-swatch--text" title="' + label + '">' +
        '<span class="sr-only">' + label + '</span>' +
      '</span>';
  }).join('');

  if (totalColors > items.length) {
    swatchesHtml += '<span class="color-swatch__view-more subheading text-subdued">+' + String(totalColors - items.length) + '</span>';
  }

  return '' +
    '<div class="product-card__swatch-list hf-mega-header__native-swatch-list">' +
      '<fieldset class="h-stack gap-1.5 sm:gap-2">' +
        '<legend class="sr-only">Colour</legend>' +
        swatchesHtml +
      '</fieldset>' +
    '</div>';
}

function setupRecentlyViewedControls(block, list, carouselSelector) {
  if (!block || !list) return;

  var carousel = block.querySelector(carouselSelector);
  if (!carousel) return;

  var existingStack = block.querySelector('.hf-mega-header__native-carousel-stack');
  if (existingStack) return;

  var listId = list.getAttribute('id');
  if (!listId) return;

  var stack = document.createElement('div');
  stack.className = 'hf-mega-header__native-carousel-stack v-stack gap-8 sm:gap-12';

  var controls = document.createElement('div');
  controls.className = 'hf-mega-header__native-carousel-shell floating-controls-container';

  var prev = document.createElement('carousel-prev-button');
  prev.className = 'floating-controls__control floating-controls__control--offset';
  prev.setAttribute('aria-controls', listId);
  prev.innerHTML = '' +
    '<button class="circle-button circle-button--xl">' +
      '<span class="sr-only">Previous</span>' +
      '<svg aria-hidden="true" focusable="false" width="14" viewBox="0 0 16 16" fill="none"><path d="M10.5 3 5.5 8l5 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg>' +
    '</button>';

  var next = document.createElement('carousel-next-button');
  next.className = 'floating-controls__control floating-controls__control--offset';
  next.setAttribute('aria-controls', listId);
  next.innerHTML = '' +
    '<button class="circle-button circle-button--xl">' +
      '<span class="sr-only">Next</span>' +
      '<svg aria-hidden="true" focusable="false" width="14" viewBox="0 0 16 16" fill="none"><path d="M5.5 3 10.5 8l-5 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg>' +
    '</button>';

  carousel.parentNode.insertBefore(stack, carousel);
  stack.appendChild(controls);
  controls.appendChild(prev);
  controls.appendChild(carousel);
  controls.appendChild(next);
}

function extractRecentlyViewedId(value) {
  if (value == null || value === '') return '';

  if (typeof value === 'number') {
    return String(value);
  }

  if (typeof value === 'string') {
    var trimmed = value.trim();
    if (!trimmed) return '';

    if (/^\d+$/.test(trimmed)) {
      return trimmed;
    }

    if (trimmed.indexOf('id:') === 0) {
      var fromPrefix = trimmed.split('id:').pop().trim();
      return /^\d+$/.test(fromPrefix) ? fromPrefix : '';
    }
  }

  if (typeof value === 'object') {
    if (value.id != null && /^\d+$/.test(String(value.id).trim())) {
      return String(value.id).trim();
    }
    if (value.product_id != null && /^\d+$/.test(String(value.product_id).trim())) {
      return String(value.product_id).trim();
    }
    if (value.productId != null && /^\d+$/.test(String(value.productId).trim())) {
      return String(value.productId).trim();
    }
  }

  return '';
}

function getRecentlyViewedIds() {
  var seen = new Set();
  var ids = [];
  var candidateKeys = [
    'theme:recently-viewed-products',
    'recentlyViewedProducts',
    'recently_viewed_products',
    'recently-viewed-products',
    'shopify_recently_viewed',
    'halo_recently_viewed',
    'recent-products'
  ];

  function pushId(id) {
    if (!id) return;
    var normalized = String(id).trim();
    if (!normalized || !/^\d+$/.test(normalized)) return;
    if (seen.has(normalized)) return;
    seen.add(normalized);
    ids.push(normalized);
  }

  function consumeParsed(parsed) {
    if (!parsed) return;

    if (Array.isArray(parsed)) {
      parsed.forEach(function (item) {
        if (Array.isArray(item)) {
          consumeParsed(item);
          return;
        }
        pushId(extractRecentlyViewedId(item));
      });
      return;
    }

    if (typeof parsed === 'object') {
      if (Array.isArray(parsed.products)) consumeParsed(parsed.products);
      if (Array.isArray(parsed.items)) consumeParsed(parsed.items);
      pushId(extractRecentlyViewedId(parsed));
      return;
    }

    pushId(extractRecentlyViewedId(parsed));
  }

  candidateKeys.forEach(function (key) {
    try {
      var raw = window.localStorage.getItem(key);
      if (!raw) return;
      try {
        consumeParsed(JSON.parse(raw));
      } catch (error) {
        consumeParsed(raw.split(','));
      }
    } catch (error) {}
  });

  var currentProductId = '';
  var productJsonNode = document.querySelector('script[type="application/ld+json"]');
  if (productJsonNode && (window.location.pathname || '').indexOf('/products/') === 0) {
    try {
      var productJson = JSON.parse(productJsonNode.textContent || '{}');
      if (productJson && productJson.productID) {
        currentProductId = String(productJson.productID).trim();
      }
    } catch (error) {}
  }

  return ids.filter(function (id) {
    return id && id !== currentProductId;
  }).slice(0, 8);
}

function getProductDataById(productId) {
  if (!productId) return Promise.resolve(null);

  return fetch('/search/suggest.json?q=id:' + encodeURIComponent(productId) + '&resources[type]=product&resources[limit]=1&resources[options][unavailable_products]=last', {
    headers: { Accept: 'application/json' }
  })
    .then(function (response) {
      if (!response.ok) throw new Error('Recently viewed lookup failed');
      return response.json();
    })
    .then(function (json) {
      var products = json && json.resources && json.resources.results && json.resources.results.products ? json.resources.results.products : [];
      if (!products.length) return null;
      var predictiveProduct = products[0];
      return getProductDataByHandle(predictiveProduct.handle).then(function (fullProduct) {
        return fullProduct || null;
      });
    })
    .catch(function () {
      return null;
    });
}

function createRecentlyViewedCard(product) {
  var pricing = getPricing({ full: product });
  var compareMarkup = pricing.compareText
    ? '<compare-at-price class="subheading text-subdued">' + escapeHtml(pricing.compareText) + '</compare-at-price>'
    : '';
  var swatchesMarkup = buildRecentlyViewedSwatchesMarkup(product);
  var productUrl = '/products/' + product.handle;
  var imageSrc = product.featured_image || 'https://placehold.co/800x1000/e9ecef/222222?text=No+Image';
  var vendorSlug = slugifyVendor(product.vendor || '');
  var vendorUrl = vendorSlug ? '/collections/' + vendorSlug : productUrl;

  var card = document.createElement('product-card');
  card.className = 'product-card product-card--bordered product-card--info-outside color-scheme color-scheme--scheme-1 hf-mega-header__native-product-card';
  if (product.handle) {
    card.setAttribute('handle', product.handle);
  }

  card.innerHTML = '' +
    '<div class="product-card__figure">' +
      '<a href="' + escapeHtml(productUrl) + '" class="product-card__media">' +
        '<img src="' + escapeHtml(imageSrc) + '" alt="' + escapeHtml(product.title || 'Product') + '" width="1600" height="2000" loading="lazy" sizes="(max-width: 699px) 74vw, (max-width: 999px) 50vw, calc((100vw - 96px) / 4)" class="product-card__image product-card__image--primary size-full object-cover aspect-portrait">' +
      '</a>' +
    '</div>' +
    '<div class="product-card__info">' +
      '<div class="v-stack gap-2.5 justify-items-center text-center">' +
        '<div class="v-stack gap-0.5">' +
          '<div class="v-stack gap-2.5">' +
            '<div class="v-stack gap-1">' +
              '<div class="v-stack gap-0.5">' +
                '<a href="' + escapeHtml(vendorUrl) + '" class="vendor subheading text-subdued">' + escapeHtml(product.vendor || '') + '</a>' +
                '<a href="' + escapeHtml(productUrl) + '" class="product-title subheading ">' + escapeHtml(product.title || '') + '</a>' +
              '</div>' +
            '</div>' +
          '</div>' +
          '<div class="v-stack gap-1">' +
            '<price-list class="price-list ">' +
              '<sale-price class="subheading text-subdued">' +
                '<span class="sr-only">Sale price</span>' + escapeHtml(pricing.priceText) +
              '</sale-price>' +
              compareMarkup +
            '</price-list>' +
          '</div>' +
        '</div>' +
        swatchesMarkup +
      '</div>' +
    '</div>';

  return card;
}

function populateRecentlyViewedTargets(products) {
  var targets = [
    { block: recentlyViewedBlock, list: recentlyViewedList },
    { block: cartEmptyRecentlyViewedBlock, list: cartEmptyRecentlyViewedList }
  ];

  targets.forEach(function (target) {
    if (!target.block || !target.list) return;

    target.list.innerHTML = '';

    if (!products || !products.length) {
      target.block.hidden = true;
      return;
    }

    products.forEach(function (product) {
      target.list.appendChild(createRecentlyViewedCard(product));
    });

    target.block.hidden = false;

    if (target.block === recentlyViewedBlock) {
      setupRecentlyViewedControls(
        recentlyViewedBlock,
        recentlyViewedList,
        '[data-hf-recently-viewed-carousel]'
      );
    }

    if (target.block === cartEmptyRecentlyViewedBlock) {
      setupRecentlyViewedControls(
        cartEmptyRecentlyViewedBlock,
        cartEmptyRecentlyViewedList,
        '[data-hf-cart-empty-recently-viewed-carousel]'
      );
    }
  });
}

function clearRecentlyViewedTargets() {
  populateRecentlyViewedTargets([]);
}

function loadRecentlyViewedProducts() {
  if ((!recentlyViewedBlock || !recentlyViewedList) && (!cartEmptyRecentlyViewedBlock || !cartEmptyRecentlyViewedList)) return;

  var ids = getRecentlyViewedIds();
  if (!ids.length) {
    clearRecentlyViewedTargets();
    return;
  }

  Promise.all(ids.map(getProductDataById))
    .then(function (products) {
      var validProducts = (products || []).filter(function (product) {
        return !!product;
      });

      if (!validProducts.length) {
        clearRecentlyViewedTargets();
        return;
      }

      populateRecentlyViewedTargets(validProducts);
    })
    .catch(function () {
      clearRecentlyViewedTargets();
    });
}

    function resetSearchState() {
      if (searchDefault) searchDefault.hidden = false;
      if (searchResults) searchResults.hidden = true;
      if (searchEmpty) searchEmpty.hidden = true;
      if (searchList) searchList.innerHTML = '';
      if (searchViewAll) searchViewAll.href = '/search';
      loadRecentlyViewedProducts();
    }

    function renderNoResults(query) {
      if (searchDefault) searchDefault.hidden = true;
      if (searchResults) searchResults.hidden = true;
      if (searchEmpty) searchEmpty.hidden = false;
      if (searchList) searchList.innerHTML = '';
      if (searchViewAll) {
        searchViewAll.href = '/search?q=' + encodeURIComponent(query) + '&type=product';
      }
    }

    function renderSearchResults(query, products) {
      if (!searchList) return;

      if (searchDefault) searchDefault.hidden = true;
      if (searchEmpty) searchEmpty.hidden = true;
      if (searchResults) searchResults.hidden = false;
      searchList.innerHTML = '';

      products.forEach(function (productRecord) {
  var predictive = productRecord && productRecord.predictive ? productRecord.predictive : productRecord;
  var full = productRecord && productRecord.full ? productRecord.full : null;

  var li = document.createElement('li');
  li.className = 'hf-mega-header__search-item-wrap';

  var link = document.createElement('a');
  link.className = 'hf-mega-header__search-item';
  link.href = (predictive && predictive.url) || (full && full.url) || '#';

  var image = document.createElement('img');
  image.className = 'hf-mega-header__search-main';
  image.src = (predictive && predictive.featured_image && predictive.featured_image.url) || (predictive && predictive.image) || (full && full.featured_image) || 'https://placehold.co/240x300/e9ecef/222222?text=No+Image';
  image.alt = (predictive && predictive.title) || (full && full.title) || 'Product';

        var meta = document.createElement('div');
        meta.className = 'hf-mega-header__search-meta';

        var vendor = document.createElement('span');
vendor.className = 'hf-mega-header__search-vendor';
vendor.textContent = (predictive && predictive.vendor) || (full && full.vendor) || '';

var title = document.createElement('span');
title.className = 'hf-mega-header__search-title';
title.textContent = (predictive && predictive.title) || (full && full.title) || '';

var pricing = getPricing(productRecord);
var priceWrap = document.createElement('div');
priceWrap.className = 'hf-mega-header__search-price-wrap';

if (pricing.compareText) {
  var compare = document.createElement('span');
  compare.className = 'hf-mega-header__search-price-compare';
  compare.textContent = pricing.compareText;
  priceWrap.appendChild(compare);
}

var price = document.createElement('span');
price.className = 'hf-mega-header__search-price' + (pricing.onSale ? ' is-sale' : '');
price.textContent = pricing.priceText;

priceWrap.appendChild(price);

meta.appendChild(vendor);
meta.appendChild(title);
meta.appendChild(priceWrap);

                var swatchData = collectVariantSwatches(full);
        var swatchItems = swatchData.items || [];
        var totalColors = swatchData.totalColors || 0;
        if (swatchItems.length) {
          var swatches = document.createElement('div');
          swatches.className = 'hf-mega-header__search-swatches';

          swatchItems.forEach(function (item) {
            if (item.src) {
              var swatchImage = document.createElement('img');
              swatchImage.className = 'hf-mega-header__search-swatch-image';
              swatchImage.src = item.src;
              swatchImage.alt = item.label;
              swatchImage.title = item.label;
              swatches.appendChild(swatchImage);
              return;
            }

            var chip = document.createElement('span');
            chip.className = 'hf-mega-header__search-swatch';
            chip.textContent = item.label;
            chip.title = item.label;
            swatches.appendChild(chip);
          });

          if (totalColors > swatchItems.length) {
            var more = document.createElement('span');
            more.className = 'hf-mega-header__search-swatch hf-mega-header__search-swatch--more';
            more.textContent = '+' + (totalColors - swatchItems.length);
            swatches.appendChild(more);
          }

          meta.appendChild(swatches);
        }

        link.appendChild(image);
        link.appendChild(meta);
        li.appendChild(link);
        searchList.appendChild(li);
      });

      if (searchViewAll) {
        searchViewAll.href = '/search?q=' + encodeURIComponent(query) + '&type=product';
        searchViewAll.hidden = false;
      }
    }

    function runPredictiveSearch(query) {
  if (!query || !query.trim()) {
    resetSearchState();
    return;
  }

  if (predictiveAbort) predictiveAbort.abort();
  predictiveAbort = new AbortController();

  var url = '/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=9&resources[options][unavailable_products]=last';

  fetch(url, {
    signal: predictiveAbort.signal,
    headers: { Accept: 'application/json' }
  })
    .then(function (response) {
      if (!response.ok) throw new Error('Predictive search failed');
      return response.json();
    })
    .then(function (json) {
      var products = json && json.resources && json.resources.results && json.resources.results.products ? json.resources.results.products : [];

      if (!products.length) {
        renderNoResults(query);
        return;
      }

      return enrichPredictiveProducts(products).then(function (enrichedProducts) {
        renderSearchResults(query, enrichedProducts);
      });
    })
    .catch(function (error) {
      if (error && error.name === 'AbortError') return;
      renderNoResults(query);
    });
}

    function onSearchInput(value) {
      clearTimeout(predictiveDebounce);
      predictiveDebounce = setTimeout(function () {
        runPredictiveSearch(value);
      }, 180);
    }
    function findTopAnnouncement() {
      var candidates = getAnnouncementSelectorCandidates();
      topAnnouncement = null;

      for (var i = 0; i < candidates.length; i += 1) {
        var match = document.querySelector(candidates[i]);
        if (match) {
          topAnnouncement = match;
          break;
        }
      }

      return topAnnouncement;
    }



function getTopAnnouncementOffset() {
  var announcement = findTopAnnouncement();
  if (!announcement) return 0;

  var rect = announcement.getBoundingClientRect();
  if (rect.height <= 0) return 0;
  if (rect.bottom <= 0) return 0;

  return Math.max(0, Math.min(rect.height, rect.bottom));
}

    function syncMainOffset() {
      var navShell = header.querySelector('.hf-mega-header__nav-shell');
      if (!navShell) return;

      var announcementOffset = getTopAnnouncementOffset();
      document.documentElement.style.setProperty('--hf-top-offset', announcementOffset + 'px');

      var navRect = navShell.getBoundingClientRect();
      var topInset = window.innerWidth <= 989 ? 16 : 20;
      var isProductPage = /\/products\//.test(path);
      var isCollectionPage = /\/collections\//.test(path);
      var contentSafetyGap = isProductPage ? 0 : 12;
      var offset = Math.ceil(navRect.height + topInset + contentSafetyGap + announcementOffset);
      // Patch: set background on html/body for product/collection pages
      if (isProductPage || isCollectionPage) {
        document.documentElement.style.setProperty('background', '#ffffff', 'important');
        document.body.style.setProperty('background', '#ffffff', 'important');
      } else {
        document.documentElement.style.removeProperty('background');
        document.body.style.removeProperty('background');
      }
      var headerSection = header.closest('.shopify-section');
      var brandSection = brandEl ? brandEl.closest('.shopify-section') : null;
      var firstMainSection = document.querySelector('#main > .shopify-section:first-child');
      var targetSection = null;

      if (mainEl) {
        mainEl.style.setProperty('padding-top', '');
        mainEl.style.setProperty('background', (isProductPage || isCollectionPage) ? '#ffffff' : 'transparent');
      }

      document.querySelectorAll('#main .shopify-section').forEach(function (section) {
        if (section !== headerSection && section !== brandSection) {
          section.style.setProperty('margin-top', '');
        }
      });

      if (firstMainSection) {
        firstMainSection.style.setProperty('margin-top', '0', 'important');
      }

      if (isProductPage || isCollectionPage) {
        if (mainEl) {
          mainEl.style.setProperty('padding-top', '0', 'important');
          mainEl.style.setProperty('background', '#ffffff', 'important');
        }

        if (firstMainSection) {
          firstMainSection.style.setProperty('margin-top', offset + 'px', 'important');
          firstMainSection.style.setProperty('background', '#ffffff', 'important');
          return;
        }

        if (mainEl) {
          mainEl.style.setProperty('padding-top', offset + 'px', 'important');
        }
        return;
      }

      if (isProductPage) {
        var productSections = document.querySelectorAll('#main .shopify-section--main-product');
        productSections.forEach(function (section) {
          if (!targetSection && section !== headerSection && section !== brandSection && !section.contains(header) && !(brandEl && section.contains(brandEl))) {
            targetSection = section;
          }
        });
      }

      if (isCollectionPage && !targetSection) {
        var mainSections = document.querySelectorAll('#main .shopify-section');
        mainSections.forEach(function (section) {
          if (!targetSection && section !== headerSection && section !== brandSection && !section.contains(header) && !(brandEl && section.contains(brandEl))) {
            targetSection = section;
          }
        });
      }

      if (targetSection) {
        targetSection.style.setProperty('margin-top', offset + 'px', 'important');
      }
    }

    function updateScrolledState() {
      var announcementOffset = getTopAnnouncementOffset();

      document.documentElement.style.setProperty('--hf-top-offset', announcementOffset + 'px');

      if (!brandEl) return;

      if (window.innerWidth <= 989) {
        brandEl.classList.add('is-hidden');
        brandEl.style.display = 'none';
        brandEl.style.opacity = '0';
        brandEl.style.visibility = 'hidden';
        brandEl.style.pointerEvents = 'none';
        return;
      }

      brandEl.classList.remove('is-hidden');
      brandEl.style.display = 'inline-flex';
      brandEl.style.transform = 'translateY(-50%)';
      brandEl.style.opacity = '1';
      brandEl.style.visibility = 'visible';
      brandEl.style.pointerEvents = 'auto';
      brandEl.style.zIndex = '2147483646';
    }


    function updateLogoVariant() {
      if (!logo || !brandEl) return;

      if (window.innerWidth <= 989) {
        brandEl.classList.add('is-hidden');
        brandEl.style.display = 'none';
        brandEl.style.opacity = '0';
        brandEl.style.visibility = 'hidden';
        brandEl.style.pointerEvents = 'none';
        return;
      }

      mountBrandToBody();

      var whiteSrc = 'https://cdn.shopify.com/s/files/1/0654/3881/0355/files/Monod_Sports_Logo_Stacked_White.png?v=1658178303';
      if (logo.getAttribute('src') !== whiteSrc) {
        logo.setAttribute('src', whiteSrc);
      }

      brandEl.classList.remove('is-hidden');
      brandEl.style.display = 'inline-flex';
      brandEl.style.mixBlendMode = 'difference';
      brandEl.style.opacity = '1';
      brandEl.style.visibility = 'visible';
      brandEl.style.pointerEvents = 'auto';
      brandEl.style.zIndex = '2147483647';
      brandEl.style.transform = 'translateY(-50%)';
      logo.style.mixBlendMode = 'normal';
      logo.style.filter = 'none';
      logo.style.opacity = '1';
    }

    window.debugLogoSampling = function () {
      if (!brandEl || !logo) {
        console.log('HF logo debug: missing brand or logo element', { brandEl: !!brandEl, logo: !!logo });
        return;
      }

      var brandStyle = window.getComputedStyle(brandEl);
      var logoStyle = window.getComputedStyle(logo);
      var mainStyle = mainEl ? window.getComputedStyle(mainEl) : null;
      console.log('HF logo blend debug', {
        brand: {
          mixBlendMode: brandStyle.mixBlendMode,
          isolation: brandStyle.isolation,
          opacity: brandStyle.opacity,
          visibility: brandStyle.visibility,
          transform: brandStyle.transform,
          position: brandStyle.position,
          zIndex: brandStyle.zIndex,
          top: brandStyle.top,
          left: brandStyle.left,
          parentTag: brandEl.parentNode ? brandEl.parentNode.tagName : null
        },
        logo: {
          mixBlendMode: logoStyle.mixBlendMode,
          filter: logoStyle.filter,
          opacity: logoStyle.opacity,
          src: logo.getAttribute('src')
        },
        main: mainStyle ? {
          background: mainStyle.backgroundColor,
          paddingTop: mainStyle.paddingTop,
          position: mainStyle.position,
          zIndex: mainStyle.zIndex
        } : null,
        body: {
          background: window.getComputedStyle(document.body).backgroundColor
        },
        html: {
          background: window.getComputedStyle(document.documentElement).backgroundColor
        },
        currentPath: path
      });
    };

    window.addEventListener('resize', function () {
      findTopAnnouncement();
      if (window.innerWidth > 989) {
        mountBrandToBody();
      }
      queueSyncMainOffset();
    });
    window.addEventListener('scroll', function () {
  queueSyncMainOffset();
}, { passive: true });

    window.addEventListener('load', function () {
      findTopAnnouncement();
      if (window.innerWidth > 989) {
        mountBrandToBody();
      }
      queueSyncMainOffset();
      setTimeout(function () {
        findTopAnnouncement();
        queueSyncMainOffset();
      }, 160);
      setTimeout(function () {
        findTopAnnouncement();
        queueSyncMainOffset();
      }, 420);
    });

        function closeAllPanels() {
      topTriggers.forEach(function (trigger) {
        trigger.classList.remove('is-active');
        trigger.setAttribute('aria-expanded', 'false');
      });

      if (searchTrigger) {
        searchTrigger.classList.remove('is-active');
        searchTrigger.setAttribute('aria-expanded', 'false');
      }

      if (cartTrigger) {
        cartTrigger.classList.remove('is-active');
        cartTrigger.setAttribute('aria-expanded', 'false');
      }

      if (notificationsTrigger) {
  notificationsTrigger.classList.remove('is-active');
  notificationsTrigger.setAttribute('aria-expanded', 'false');
}

      panels.forEach(function (panel) {
        panel.classList.remove('is-open');
      });

      if (searchPanel) {
        searchPanel.classList.remove('is-open');
      }

      if (cartPanel) {
        cartPanel.classList.remove('is-open');
      }

      if (notificationsPanel) {
  notificationsPanel.classList.remove('is-open');
}

      header.querySelectorAll('[data-hf-right-panel]').forEach(function (panel) {
        panel.classList.remove('is-active');
      });

      rightPlaceholders.forEach(function (placeholder) {
        placeholder.classList.remove('is-hidden');
      });
      document.body.style.overflow = '';
      if (overlay) overlay.classList.remove('is-visible');
      header.classList.remove('hf-menu-open', 'hf-search-open', 'hf-cart-open');
      document.documentElement.classList.remove('hf-menu-open', 'hf-search-open', 'hf-cart-open');
    }

        function setActiveSecond(topIndex, secondIndex) {
      var activeExists = secondIndex !== 'intro';

      header.querySelectorAll('.hf-mega-header__scroll-area').forEach(function (scrollArea) {
        scrollArea.classList.remove('has-active-item');
      });

      secondTriggers.forEach(function (trigger) {
        var sameTop = trigger.getAttribute('data-top-index') === String(topIndex);
        var sameSecond = trigger.getAttribute('data-second-index') === String(secondIndex);
        var isActive = sameTop && sameSecond;
        trigger.classList.toggle('is-active', isActive);

        if (sameTop && activeExists) {
          var scrollArea = trigger.closest('.hf-mega-header__scroll-area');
          if (scrollArea) scrollArea.classList.add('has-active-item');
        }
      });

      header.querySelectorAll('.hf-mega-header__second-link').forEach(function (link) {
        link.classList.remove('is-active');
      });

      header.querySelectorAll('[data-hf-right-panel]').forEach(function (panel) {
        var sameTop = panel.getAttribute('data-top-index') === String(topIndex);
        var sameSecond = panel.getAttribute('data-second-index') === String(secondIndex);
        panel.classList.toggle('is-active', sameTop && sameSecond);
      });

      rightPlaceholders.forEach(function (placeholder) {
        var sameTop = placeholder.getAttribute('data-top-index') === String(topIndex);
        placeholder.classList.toggle('is-hidden', sameTop && secondIndex !== 'intro');
      });
    }

    function openPanel(topIndex) {
      closeAllPanels();

      var activeTrigger = header.querySelector('[data-hf-top-trigger][data-top-index="' + topIndex + '"]');
      var activePanel = header.querySelector('[data-top-panel="' + topIndex + '"]');
      if (!activeTrigger || !activePanel) return;

      activeTrigger.classList.add('is-active');
      activeTrigger.setAttribute('aria-expanded', 'true');
      activePanel.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      if (overlay) overlay.classList.add('is-visible');
      header.classList.add('hf-menu-open');
      document.documentElement.classList.add('hf-menu-open');

      setActiveSecond(topIndex, 'intro');
    }

    function openSearchPanel() {
      closeAllPanels();
      if (!searchPanel) return;

      if (searchTrigger) {
        searchTrigger.classList.add('is-active');
        searchTrigger.setAttribute('aria-expanded', 'true');
      }

      searchPanel.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      if (overlay) overlay.classList.add('is-visible');
      header.classList.add('hf-menu-open', 'hf-search-open');
      document.documentElement.classList.add('hf-menu-open', 'hf-search-open');

      resetSearchState();

      if (searchInput) {
        setTimeout(function () {
          searchInput.focus();
        }, 60);
      }
    }

    function openCartPanel() {
      closeAllPanels();
      if (!cartPanel) return;

      if (cartTrigger) {
        cartTrigger.classList.add('is-active');
        cartTrigger.setAttribute('aria-expanded', 'true');
      }

      cartPanel.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      if (overlay) overlay.classList.add('is-visible');
      header.classList.add('hf-menu-open', 'hf-cart-open');
      document.documentElement.classList.add('hf-menu-open', 'hf-cart-open');

      loadCart().then(function () {
  if (cartItems) {
    cartItems.scrollTop = 0;
  }
});
    }
  function resetNotificationsDetail() {
  if (notificationsFeed) notificationsFeed.hidden = false;
  if (notificationDetail) notificationDetail.hidden = true;
  if (notificationsWrap) notificationsWrap.classList.remove('is-detail-open');

  if (notificationDetailImage) {
    notificationDetailImage.src = '';
    notificationDetailImage.alt = '';
  }

  if (notificationDetailTitle) {
    notificationDetailTitle.textContent = '';
  }

  if (notificationDetailBody) {
    notificationDetailBody.textContent = '';
  }

  if (notificationDetailButton) {
    notificationDetailButton.setAttribute('href', '#');
    notificationDetailButton.setAttribute('aria-label', 'Read more notification');

    var buttonContent = notificationDetailButton.querySelector('button-content');
    if (buttonContent) {
      buttonContent.textContent = 'Read more';
      buttonContent.setAttribute('rotated-text', 'Read more');
    }
  }

  if (notificationDetailSecondButton) {
    notificationDetailSecondButton.hidden = true;
    notificationDetailSecondButton.setAttribute('href', '#');
    notificationDetailSecondButton.setAttribute('aria-label', 'Read more notification');

    var secondButtonContent = notificationDetailSecondButton.querySelector('button-content');
    if (secondButtonContent) {
      secondButtonContent.textContent = 'Read more';
      secondButtonContent.setAttribute('rotated-text', 'Read more');
    }
  }
}

function openNotificationDetail(item) {
  if (!item) return;

  var notificationId = item.getAttribute('data-notification-id') || '';
  if (notificationId) {
    markNotificationAsRead(notificationId);
    updateNotificationUnreadUi();
  }

  var title = item.getAttribute('data-title') || '';
  var body = item.getAttribute('data-body') || '';
  var buttonLabel = item.getAttribute('data-button-label') || 'Read more';
  var buttonLink = item.getAttribute('data-button-link') || '#';
  var secondButtonLabel = item.getAttribute('data-second-button-label') || '';
  var secondButtonLink = item.getAttribute('data-second-button-link') || '';
  var image = item.getAttribute('data-image') || '';

  if (notificationDetailImage) {
    notificationDetailImage.src = image;
    notificationDetailImage.alt = title;
  }

  if (notificationDetailTitle) {
    notificationDetailTitle.textContent = title;
  }

  if (notificationDetailBody) {
    notificationDetailBody.textContent = body;
  }

  if (notificationDetailButton) {
    notificationDetailButton.setAttribute('href', buttonLink);
    notificationDetailButton.setAttribute('aria-label', buttonLabel);

    var buttonContent = notificationDetailButton.querySelector('button-content');
    if (buttonContent) {
      buttonContent.textContent = buttonLabel;
      buttonContent.setAttribute('rotated-text', buttonLabel);
    }
  }

  if (notificationDetailSecondButton) {
    var hasSecondButton = !!(secondButtonLabel && secondButtonLink);
    notificationDetailSecondButton.hidden = !hasSecondButton;

    if (hasSecondButton) {
      notificationDetailSecondButton.setAttribute('href', secondButtonLink);
      notificationDetailSecondButton.setAttribute('aria-label', secondButtonLabel);

      var secondButtonContent = notificationDetailSecondButton.querySelector('button-content');
      if (secondButtonContent) {
        secondButtonContent.textContent = secondButtonLabel;
        secondButtonContent.setAttribute('rotated-text', secondButtonLabel);
      }
    }
  }

  if (notificationsFeed) notificationsFeed.hidden = true;
  if (notificationDetail) notificationDetail.hidden = false;
  if (notificationsWrap) notificationsWrap.classList.add('is-detail-open');
}

function openNotificationsPanel() {
  closeAllPanels();
  if (!notificationsPanel) return;

  if (notificationsTrigger) {
    notificationsTrigger.classList.add('is-active');
    notificationsTrigger.setAttribute('aria-expanded', 'true');
  }

  resetNotificationsDetail();
  notificationsPanel.classList.add('is-open');
  document.body.style.overflow = 'hidden';
  if (overlay) overlay.classList.add('is-visible');
  header.classList.add('hf-menu-open');
  document.documentElement.classList.add('hf-menu-open');
}

    topTriggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var topIndex = trigger.getAttribute('data-top-index');
        var isOpen = trigger.classList.contains('is-active');
        if (isOpen) {
          closeAllPanels();
        } else {
          openPanel(topIndex);
        }
      });
    });

    if (searchTrigger) {
      searchTrigger.addEventListener('click', function () {
        var isOpen = searchPanel && searchPanel.classList.contains('is-open');
        if (isOpen) {
          closeAllPanels();
        } else {
          openSearchPanel();
        }
      });
    }


    if (cartTrigger) {
      cartTrigger.addEventListener('click', function () {
        var isOpen = cartPanel && cartPanel.classList.contains('is-open');
        if (isOpen) {
          closeAllPanels();
        } else {
          openCartPanel();
        }
      });
    }

    if (notificationsTrigger) {
  notificationsTrigger.addEventListener('click', function () {
    var isOpen = notificationsPanel && notificationsPanel.classList.contains('is-open');
    if (isOpen) {
      closeAllPanels();
    } else {
      openNotificationsPanel();
    }
  });
}


    secondTriggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var topIndex = trigger.getAttribute('data-top-index');
        var secondIndex = trigger.getAttribute('data-second-index');
        var isAlreadyActive = trigger.classList.contains('is-active');

        if (isAlreadyActive) {
          setActiveSecond(topIndex, 'intro');
        } else {
          setActiveSecond(topIndex, secondIndex);
        }
      });
    });

    notificationItems.forEach(function (item) {
  item.addEventListener('click', function () {
    openNotificationDetail(item);
  });
});

if (notificationBack) {
  notificationBack.addEventListener('click', function () {
    resetNotificationsDetail();
  });
}

    if (searchInput) {
      searchInput.addEventListener('input', function (event) {
        onSearchInput(event.target.value);
      });
    }

    if (searchClear) {
      searchClear.addEventListener('click', function () {
        if (searchInput) searchInput.value = '';
        resetSearchState();
        if (searchInput) searchInput.focus();
      });
    }

    if (searchEmptyClear) {
      searchEmptyClear.addEventListener('click', function () {
        if (searchInput) searchInput.value = '';
        resetSearchState();
        if (searchInput) searchInput.focus();
      });
    }

    suggestedSearches.forEach(function (button) {
      button.addEventListener('click', function () {
        var query = button.getAttribute('data-hf-suggested-query') || '';
        if (searchInput) searchInput.value = query;
        runPredictiveSearch(query);
      });
    });

    if (overlay) {
      overlay.addEventListener('click', function () {
        closeAllPanels();
        if (shell) shell.classList.remove('is-mobile-open');
        if (mobileToggle) mobileToggle.setAttribute('aria-expanded', 'false');
      });
    }

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') {
        closeAllPanels();
        if (shell) shell.classList.remove('is-mobile-open');
        if (mobileToggle) mobileToggle.setAttribute('aria-expanded', 'false');
      }
    });

    if (mobileToggle) {
      mobileToggle.addEventListener('click', function () {
        var isOpen = shell.classList.toggle('is-mobile-open');
        mobileToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');

        if (!isOpen) {
          closeAllPanels();
        }
      });
    }

    document.addEventListener('click', function (event) {
  var clickedInsideHeader = event.target.closest('[data-hf-click-area]') || event.target.closest('[data-hf-panel]') || event.target.closest('[data-hf-search-panel]') || event.target.closest('[data-hf-search-trigger]') || event.target.closest('[data-hf-cart-panel]') || event.target.closest('[data-hf-cart-trigger]') || event.target.closest('[data-hf-notifications-panel]') || event.target.closest('[data-hf-notifications-trigger]');

  if (!clickedInsideHeader) {
    closeAllPanels();
    if (shell) shell.classList.remove('is-mobile-open');
    if (mobileToggle) mobileToggle.setAttribute('aria-expanded', 'false');
  }
});

function resetCartDiscountBanners() {
  header.querySelectorAll('cart-discount-banner').forEach(function (banner) {
    banner.hidden = true;
  });
}

document.addEventListener('cart:refresh', function () {
  resetCartDiscountBanners();
  loadCart();
});

if (!window.__hfCartAddOpenHookInstalled) {
  window.__hfCartAddOpenHookInstalled = true;

  var originalFetch = window.fetch;
  window.fetch = function (input, init) {
    var requestUrl = '';

    if (typeof input === 'string') {
      requestUrl = input;
    } else if (input && typeof input.url === 'string') {
      requestUrl = input.url;
    }

    return originalFetch.apply(this, arguments).then(function (response) {
      var normalizedUrl = String(requestUrl || '');
      var isCartAddRequest = normalizedUrl.indexOf('/cart/add') > -1;

      if (isCartAddRequest && response && response.ok) {
        window.setTimeout(function () {
          openCartAfterAdd();
        }, 0);
      }

      return response;
    });
  };
}

    updateNotificationUnreadUi();
    loadCart();
    findTopAnnouncement();
    if (window.innerWidth > 989) {
      mountBrandToBody();
    }
    queueSyncMainOffset();

    var shouldAnimateIntro = false;
    try {
      shouldAnimateIntro = !sessionStorage.getItem(INTRO_KEY);
      if (shouldAnimateIntro) {
        sessionStorage.setItem(INTRO_KEY, 'true');
        header.classList.add('hf-mega-header--intro');
      }
    } catch (error) {
      shouldAnimateIntro = true;
      header.classList.add('hf-mega-header--intro');
    }

    requestAnimationFrame(function () {
      queueSyncMainOffset();
      setTimeout(queueSyncMainOffset, 120);
      setTimeout(queueSyncMainOffset, 320);
      setTimeout(queueSyncMainOffset, 700);

      requestAnimationFrame(function () {
        header.classList.add('is-loaded');
        queueSyncMainOffset();
        setTimeout(queueSyncMainOffset, 120);
        setTimeout(queueSyncMainOffset, 320);
        setTimeout(queueSyncMainOffset, 700);
        setTimeout(queueSyncMainOffset, 1200);

        if (!shouldAnimateIntro) {
          header.classList.remove('hf-mega-header--intro');
        } else {
          setTimeout(function () {
            header.classList.remove('hf-mega-header--intro');
          }, 500);
        }
      });
    });
  })();
